import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Modal,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { Table } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { compose, withHandlers, withState } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import RequiredButton from '../atoms/RequiredButton';
import ValidationText from '../atoms/ValidationText';
import SettingMenuFreeConfirmModal from './SettingMenuFreeConfirmModal';
import {
  settingMenuFree,
  SETTING_MENU_FREE_SUCCESS,
  deleteSettingMenuFree,
  DELETE_SETTING_MENU_FREE_SUCCESS
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import ShowHideSwitchButton from '../atoms/ShowHideSwitchButton';

const styles = {
  contentContainer: {
    padding: '0 0 40px',
    backgroundColor: '#fff',
    borderRadius: 4,
    maxHeight: '100%',
    overflowY: 'auto'
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  closeButton: {
    cursor: 'pointer'
  },
  closeIcon: {
    width: '24px',
    height: '24px'
  },
  header: {
    textAlign: 'right',
    padding: '16px'
  },
  body: {
    padding: '0 40px'
  },
  table: {
    width: '100%'
  },
  tableHeader: {
    backgroundColor: 'rgba(224, 224, 224, 1)',
    marginTop: '5px'
  },
  tableCell: {
    borderTop: '1px solid rgba(224, 224, 224, 1)'
  },
  textField: {
    width: '100%'
  },
  marginTop20: {
    marginTop: 20
  },
  buttonConfirm: {
    width: '100%'
  },
  buttonDelete: {
    fontWeight: 'bold',
    border: '1px solid #F50057',
    color: '#F50057',
    marginTop: 20,
    width: '100%'
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  dialogSuccess: {
    padding: 20
  },
  titleSuccess: {
    color: 'black',
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 10,
    textAlign: 'center'
  },
  bodySuccess: {
    color: 'black',
    fontSize: 16,
    marginBottom: 10,
    textAlign: 'center'
  },
  buttonConfirmDelete: {
    backgroundColor: '#F50057',
    color: '#ffffff',
    width: '100%',

    '&:hover, &:focus': {
      backgroundColor: '#F50057',
      color: '#ffffff'
    }
  },
  headerDeleteModal: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  switchButtonBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20
  },
  filterBox: {
    display: 'flex',
    marginTop: 20
  }
};

const enhance = compose(
  withState('menuDetailSettingId', 'setMenuDetailSettingId', props => {
    return props.menuSetting.menuDetailSettingId;
  }),
  withState('gochiKidFreeStartDate', 'setGochiKidFreeStartDate', props => {
    return props.menuSetting.gochiKidFreeStartDate;
  }),
  withState('gochiKidFreeEndDate', 'setGochiKidFreeEndDate', props => {
    return props.menuSetting.gochiKidFreeEndDate;
  }),
  withState('gochiKidFreeFilterFlag', 'setGochiKidFreeFilterFlag', props => {
    return props.menuSetting.gochiKidFreeFilterFlag || 0;
  }),
  withState('gochiKidFreeSet', 'setGochiKidFreeSet', props => {
    return props.menuSetting.gochiKidFreeSet || 0;
  }),
  withState('gochiKidFreePoorSet', 'setGochiKidFreePoorSet', props => {
    return props.menuSetting.gochiKidFreePoorSet || 0;
  }),
  withState('gochiKidFreeNormalSet', 'setGochiKidFreeNormalSet', props => {
    return props.menuSetting.gochiKidFreeNormalSet || 0;
  }),
  withState('gochiKidFreeStartDateError', 'setGochiKidFreeStartDateError', ''),
  withState('gochiKidFreeEndDateError', 'setGochiKidFreeEndDateError', ''),
  withState('gochiKidFreeSetError', 'setGochiKidFreeSetError', ''),
  withState('gochiKidFreePoorSetError', 'setGochiKidFreePoorSetError', ''),
  withState('gochiKidFreeNormalSetError', 'setGochiKidFreeNormalSetError', ''),
  withState('openConfirmModal', 'setOpenConfirmModal', false),
  withState('openSuccessModal', 'setOpenSuccessModal', false),
  withState('titleSuccess', 'setTitleSuccess', ''),
  withState('bodySuccess', 'setBodySuccess', ''),
  withState('openDeleteModal', 'setOpenDeleteModal', false),
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        {
          settingMenuFree,
          deleteSettingMenuFree
        },
        dispatch
      )
    })
  ),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    progress,
    updateOpenSettingMenuFreeModal,
    menuSetting,
    menuDetailSettingId,
    gochiKidFreeStartDate,
    setGochiKidFreeStartDate,
    gochiKidFreeStartDateError,
    setGochiKidFreeStartDateError,
    gochiKidFreeEndDate,
    setGochiKidFreeEndDate,
    gochiKidFreeEndDateError,
    setGochiKidFreeEndDateError,
    gochiKidFreeFilterFlag,
    setGochiKidFreeFilterFlag,
    gochiKidFreeSet,
    setGochiKidFreeSet,
    gochiKidFreeSetError,
    setGochiKidFreeSetError,
    gochiKidFreePoorSet,
    setGochiKidFreePoorSet,
    gochiKidFreePoorSetError,
    setGochiKidFreePoorSetError,
    gochiKidFreeNormalSet,
    setGochiKidFreeNormalSet,
    gochiKidFreeNormalSetError,
    setGochiKidFreeNormalSetError,
    openConfirmModal,
    setOpenConfirmModal,
    handleChangePage,
    selectedPage,
    rowsPerPage,
    openSuccessModal,
    setOpenSuccessModal,
    titleSuccess,
    setTitleSuccess,
    bodySuccess,
    setBodySuccess,
    openDeleteModal,
    setOpenDeleteModal
  }) => {
    const MAX_VALUE = 999999999;

    const menuSettingConfirm = {
      menuDetailSettingId,
      gochiKidFreeStartDate,
      gochiKidFreeEndDate,
      gochiKidFreeFilterFlag,
      gochiKidFreeSet,
      gochiKidFreePoorSet,
      gochiKidFreeNormalSet
    };

    const errors = {
      gochiKidFreeStartDateError,
      gochiKidFreeEndDateError,
      gochiKidFreeSetError,
      gochiKidFreePoorSetError,
      gochiKidFreeNormalSetError
    };

    const handleChangeGochiKidFreeStartDate = value => {
      if (value) {
        const newVal = moment(value);
        const res = gochiKidFreeStartDate
          ? moment(gochiKidFreeStartDate)
          : moment();
        res.set({
          year: newVal.get('year'),
          date: newVal.get('date'),
          month: newVal.get('month')
        });
        setGochiKidFreeStartDate(res.format('YYYY-MM-DD'));
      } else {
        setGochiKidFreeStartDate(null);
      }
    };

    const handleChangeGochiKidFreeEndDate = value => {
      if (value) {
        const newVal = moment(value);
        const res = gochiKidFreeEndDate
          ? moment(gochiKidFreeEndDate)
          : moment();
        res.set({
          year: newVal.get('year'),
          date: newVal.get('date'),
          month: newVal.get('month')
        });
        setGochiKidFreeEndDate(res.format('YYYY-MM-DD'));
      } else {
        setGochiKidFreeEndDate(null);
      }
    };

    const handleChangeGochiKidFreePoorSet = value => {
      let poorSet = value;
      let normalSet = gochiKidFreeNormalSet;

      if (value === '' || !/^\d+$/.test(value)) {
        poorSet = 0;
      }

      if (
        gochiKidFreeNormalSet === '' ||
        !/^\d+$/.test(gochiKidFreeNormalSet)
      ) {
        normalSet = 0;
      }

      if (parseInt(poorSet, 10) <= MAX_VALUE) {
        setGochiKidFreePoorSet(value);
        setGochiKidFreeSetError('');
        setGochiKidFreeSet(parseInt(poorSet, 10) + parseInt(normalSet, 10));
      }
    };

    const handleChangeGochiKidNormalSet = value => {
      let poorSet = gochiKidFreePoorSet;
      let normalSet = value;

      if (gochiKidFreePoorSet === '' || !/^\d+$/.test(gochiKidFreePoorSet)) {
        poorSet = 0;
      }

      if (value === '' || !/^\d+$/.test(value)) {
        normalSet = 0;
      }

      if (parseInt(normalSet, 10) <= MAX_VALUE) {
        setGochiKidFreeNormalSet(value);
        setGochiKidFreeSetError('');
        setGochiKidFreeSet(parseInt(poorSet, 10) + parseInt(normalSet, 10));
      }
    };

    const showHideOpenAction = param => {
      setGochiKidFreeFilterFlag(param === 1 ? 0 : 1);
      setGochiKidFreePoorSet(0);
      setGochiKidFreeNormalSet(0);
      setGochiKidFreeSet(0);
      setGochiKidFreeSetError('');
      setGochiKidFreePoorSetError('');
      setGochiKidFreeNormalSetError('');
    };

    const validGochiKidFreeStartDate = () => {
      const value = gochiKidFreeStartDate;
      const minDate =
        menuSetting.gochiKidFreeStartDate &&
        moment(menuSetting.gochiKidFreeStartDate).isBefore(moment())
          ? moment(menuSetting.gochiKidFreeStartDate).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD');
      if (value === null) {
        setGochiKidFreeStartDateError('必須項目です。');
        return 1;
      }
      if (moment(value).isBefore(moment(minDate))) {
        setGochiKidFreeEndDateError('終了日を正しく入力ください。');
        return 1;
      }
      setGochiKidFreeStartDateError('');
      setGochiKidFreeStartDate(value);
      return 0;
    };

    const validGochiKidFreeEndDate = () => {
      const value = gochiKidFreeEndDate;
      if (value === null) {
        setGochiKidFreeEndDateError('必須項目です。');
        return 1;
      }
      if (moment(value).isBefore(moment(gochiKidFreeStartDate))) {
        setGochiKidFreeEndDateError('終了日を正しく入力ください。');
        return 1;
      }
      setGochiKidFreeEndDateError('');
      setGochiKidFreeEndDate(value);
      return 0;
    };

    const validGochiKidFreeSet = () => {
      const value = gochiKidFreeSet;
      if (value === '') {
        setGochiKidFreeSetError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setGochiKidFreeSetError('半角数字のみ入力してください。');
        return 1;
      }
      if (value <= 0) {
        setGochiKidFreeSetError('必須項目です。');
        return 1;
      }
      setGochiKidFreeSetError('');
      setGochiKidFreeSet(parseInt(value, 10));
      return 0;
    };

    const validGochiKidFreePoorSet = () => {
      const value = gochiKidFreePoorSet;

      if (value === '') {
        setGochiKidFreePoorSetError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setGochiKidFreePoorSetError('半角数字のみ入力してください。');
        return 1;
      }
      setGochiKidFreePoorSetError('');
      setGochiKidFreePoorSet(parseInt(value, 10));
      return 0;
    };

    const validGochiKidFreeNormalSet = () => {
      const value = gochiKidFreeNormalSet;

      if (value === '') {
        setGochiKidFreeNormalSetError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setGochiKidFreeNormalSetError('半角数字のみ入力してください。');
        return 1;
      }
      setGochiKidFreeNormalSetError('');
      setGochiKidFreeNormalSet(parseInt(value, 10));
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      errorCount =
        validGochiKidFreeStartDate() +
        validGochiKidFreeEndDate() +
        validGochiKidFreeSet();

      if (gochiKidFreeFilterFlag === 1) {
        errorCount =
          errorCount +
          validGochiKidFreePoorSet() +
          validGochiKidFreeNormalSet();
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setOpenConfirmModal(true);
      }
    };

    const updateSettingMenuFree = async () => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const response = await actions
        .settingMenuFree(menuSetting.menuId, menuSettingConfirm)
        .then(data => checkSession(data));

      if (response.type === SETTING_MENU_FREE_SUCCESS) {
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
        setTitleSuccess('無料メニュー追加');
        setBodySuccess('無料メニュー追加を完了しました。');
        setOpenSuccessModal(true);
      } else {
        setOpenConfirmModal(false);
        progress.updateLoading(false);
        progress.setResultMessage('エラーが発生しました！');
      }
    };

    const deleteSettingMenuFreeByMenuId = async () => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const response = await actions
        .deleteSettingMenuFree(menuSetting.menuId)
        .then(data => checkSession(data));

      if (response.type === DELETE_SETTING_MENU_FREE_SUCCESS) {
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
        setTitleSuccess('解除 完了');
        setBodySuccess(
          `${menuSetting.menuName}の無料メニュー設定を解除完了しました`
        );
        setOpenDeleteModal(false);
        setOpenSuccessModal(true);
      } else {
        setOpenDeleteModal(false);
        progress.updateLoading(false);
        progress.setResultMessage('エラーが発生しました！');
      }
    };

    const handleCloseSuccessModal = () => {
      handleChangePage(null, selectedPage, rowsPerPage);
      setOpenSuccessModal(false);
      setOpenConfirmModal(false);
      setOpenDeleteModal(false);
      setTitleSuccess('');
      setBodySuccess('');
      updateOpenSettingMenuFreeModal(false);
    };

    return (
      <>
        <div className={classes.contentContainer}>
          <div className={classes.header}>
            <Button
              className={classes.closeButton}
              onClick={() => {
                updateOpenSettingMenuFreeModal(false);
              }}
            >
              <CloseIcon className={classes.closeIcon} />
            </Button>
          </div>
          <div className={classes.body}>
            <Typography className={classes.title} variant="h6">
              無料メニュー設定
            </Typography>
            <Table className={classes.table}>
              <TableHead className={classes.tableHeader}>
                <TableRow>
                  <TableCell className={classes.tableCell}>
                    メニューID
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    メニュー名
                  </TableCell>
                  <TableCell className={classes.tableCell}>税込価格</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{menuSetting.menuId}</TableCell>
                  <TableCell>{menuSetting.menuName}</TableCell>
                  <TableCell>{menuSetting.includedTaxPrice}</TableCell>
                </TableRow>
              </TableBody>
            </Table>

            <div>
              <div className={classes.marginTop20}>
                <RequiredButton />
                <div>
                  <TextField
                    required
                    label="無料提供 開始日"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      inputProps: {
                        min:
                          menuSetting.gochiKidFreeStartDate &&
                          moment(menuSetting.gochiKidFreeStartDate).isBefore(
                            moment()
                          )
                            ? moment(menuSetting.gochiKidFreeStartDate).format(
                                'YYYY-MM-DD'
                              )
                            : moment().format('YYYY-MM-DD')
                      }
                    }}
                    value={
                      gochiKidFreeStartDate
                        ? moment(gochiKidFreeStartDate).format('YYYY-MM-DD')
                        : null
                    }
                    onChange={e => {
                      handleChangeGochiKidFreeStartDate(e.target.value);
                    }}
                    onBlur={validGochiKidFreeStartDate}
                  />
                </div>
                <ValidationText message={errors.gochiKidFreeStartDateError} />
              </div>

              <div className={classes.marginTop20}>
                <RequiredButton />
                <div>
                  <TextField
                    required
                    label="無料提供 終了日"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      inputProps: {
                        min: gochiKidFreeStartDate
                          ? moment(gochiKidFreeStartDate).format('YYYY-MM-DD')
                          : moment().format('YYYY-MM-DD')
                      }
                    }}
                    value={
                      gochiKidFreeEndDate
                        ? moment(gochiKidFreeEndDate).format('YYYY-MM-DD')
                        : null
                    }
                    onChange={e => {
                      handleChangeGochiKidFreeEndDate(e.target.value);
                    }}
                    onBlur={validGochiKidFreeEndDate}
                  />
                </div>
                <ValidationText message={errors.gochiKidFreeEndDateError} />
              </div>

              <div className={classes.switchButtonBox}>
                <span style={{ marginRight: 5 }}>詳細</span>
                <ShowHideSwitchButton
                  params={gochiKidFreeFilterFlag}
                  onClickAction={showHideOpenAction}
                  showHide={gochiKidFreeFilterFlag}
                  disabled={menuDetailSettingId !== null}
                />
              </div>

              <div>
                <RequiredButton />
                <div>
                  <TextField
                    required
                    label="食数（無料提供総数）"
                    className={classes.textField}
                    margin="normal"
                    value={gochiKidFreeSet}
                    onChange={e => {
                      setGochiKidFreeSet(e.target.value.trim());
                    }}
                    disabled={gochiKidFreeFilterFlag === 1}
                    onBlur={validGochiKidFreeSet}
                  />
                </div>
                <ValidationText message={errors.gochiKidFreeSetError} />
              </div>
            </div>

            {gochiKidFreeFilterFlag === 1 && (
              <div className={classes.filterBox}>
                <div className={classes.textField} style={{ marginRight: 30 }}>
                  <RequiredButton />
                  <div>
                    <TextField
                      required
                      label="一般食数"
                      className={classes.textField}
                      margin="normal"
                      value={gochiKidFreeNormalSet}
                      onChange={e => {
                        handleChangeGochiKidNormalSet(e.target.value.trim());
                      }}
                      onBlur={validGochiKidFreeNormalSet}
                    />
                  </div>
                  <ValidationText message={errors.gochiKidFreeNormalSetError} />
                </div>
                <div className={classes.textField}>
                  <RequiredButton />
                  <div>
                    <TextField
                      required
                      label="応援キッズ食数"
                      className={classes.textField}
                      margin="normal"
                      value={gochiKidFreePoorSet}
                      onChange={e => {
                        handleChangeGochiKidFreePoorSet(e.target.value.trim());
                      }}
                      onBlur={validGochiKidFreePoorSet}
                    />
                  </div>
                  <ValidationText message={errors.gochiKidFreePoorSetError} />
                </div>
              </div>
            )}

            <div className={classes.marginTop20}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  confirmAction();
                }}
                className={classes.buttonConfirm}
              >
                更新する
              </Button>
              <Button
                className={classes.buttonDelete}
                onClick={() => {
                  if (menuDetailSettingId) setOpenDeleteModal(true);
                }}
              >
                解除する
              </Button>
            </div>
          </div>
        </div>

        <Modal
          className={classes.modal}
          open={openConfirmModal}
          onClose={() => {
            setOpenConfirmModal(false);
          }}
        >
          <SettingMenuFreeConfirmModal
            setOpenConfirmModal={setOpenConfirmModal}
            menuSetting={menuSetting}
            menuSettingConfirm={menuSettingConfirm}
            updateSettingMenuFree={updateSettingMenuFree}
          />
        </Modal>

        <Dialog
          open={openSuccessModal}
          onClose={() => {
            handleCloseSuccessModal();
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className={classes.dialogSuccess}>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div className={classes.titleSuccess}>{titleSuccess}</div>
                <div className={classes.bodySuccess}>{bodySuccess}</div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handleCloseSuccessModal();
                }}
                className={classes.buttonConfirm}
              >
                閉じる
              </Button>
            </DialogActions>
          </div>
        </Dialog>

        <Dialog
          open={openDeleteModal}
          onClose={() => {
            setOpenDeleteModal(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className={classes.dialogSuccess}>
            <div className={classes.headerDeleteModal}>
              <Button
                className={classes.closeButton}
                onClick={() => {
                  setOpenDeleteModal(false);
                }}
              >
                <CloseIcon className={classes.closeIcon} />
              </Button>
            </div>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div className={classes.titleSuccess}>解除 確認</div>
                <div className={classes.bodySuccess}>
                  {menuSetting.menuName}
                  の無料メニュー設定を解除しますか？
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => {
                  deleteSettingMenuFreeByMenuId();
                }}
                className={classes.buttonConfirmDelete}
              >
                解除する
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
